module.exports = __webpack_public_path__ + "static/media/Press_Room_882x496_Colour.1583cb3f.png";